import {action, observable} from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";
import {joinUrl} from "@utils/index";

export default class streamInfoState extends baseState {
    @observable list = {};
    @action
    setList = data => this.list = data;

    getList = data => {
        return this.fetch({
            url: apiUrl.LOG.STREAM_INFO.LIST,
            method: 'get',
            setState: "setList",
            data
        });
    }
}
